module.exports = __webpack_public_path__ + "img/small1-cn.45fd6e84.png";